<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 12 8">
    <path :style="iconStyle" d="M6,8,0,0H12Z" />
  </svg>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '8',
    },
    width: {
      type: String,
      default: '12',
    },
    color: {
      type: String,
      default: 'icon-color-grey',
    },
  },
  computed: {
    /**
     * Icon Style
     * @param {void}
     * @returns {string} - Color
     * @description Assigns the specific color to the icon
     */
    iconStyle: function () {
      return {
        fill: ['$' + this.color, `var(--${this.color})`],
      }
    },
  },
}
</script>
